import React from "react"
import Clickable from "@components/clickable"
import classnames from "@utils/classnames"

import styles from "./button.module.scss"

const Button = ({ className, color, ...props }) => {
  const classNames = classnames(styles.btn, styles[color], className)
  return <Clickable className={classNames} {...props} />
}

export default Button
